import { Menu, styled } from '@mui/material';
import { forwardRef } from 'react';

const CustomMenu = styled(Menu)(({ theme }) => {
    return {
        '& .MuiBackdrop-root': {
            background: 'transparent',
        },
        '& .MuiPaper-root': {
            boxShadow: theme.palette.ensightful.shadows[1],
            borderRadius: '8px',
        },
        '& .MuiList-root': {
            padding: theme.spacing(2),
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(1),
        },
    };
});

export default forwardRef((props, ref) => {
    return <CustomMenu ref={ref} {...props} />;
});
